import { Record } from 'immutable';
import { PENDING } from './states.js';
export class MetaStateRecord extends Record({
    state: PENDING,
    timestamp: new Date(),
    error: undefined
}) {
    toJS() {
        return super.toJS();
    }
}
//# sourceMappingURL=meta.js.map